module.exports = __webpack_public_path__ + "static/assets/8d23b0cadc337fa411bc15541a998ce8.svg";